import * as React from 'react';
import type { SVGProps } from 'react';
const SvgReport = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={12}
    height={16}
    fill="currentColor"
    viewBox="0 0 12 16"
    {...props}
  >
    <path
      fill="currentColor"
      d="M1.998 15.353q-.646 0-1.099-.455a1.5 1.5 0 0 1-.452-1.101V2.204a1.5 1.5 0 0 1 .455-1.101A1.5 1.5 0 0 1 2.004.648h5.21q.309 0 .588.11.28.108.517.347l2.777 2.776a1.5 1.5 0 0 1 .456 1.104v8.812a1.5 1.5 0 0 1-.455 1.101q-.454.455-1.102.455zM6.846 4.576V2.204H2.004v11.593h7.992V5.354H7.624a.75.75 0 0 1-.553-.225.75.75 0 0 1-.225-.553"
    />
  </svg>
);
export default SvgReport;
